import CommonSelect from "components/select";
import { Label } from "ui/components/label";
import { fetchBillableStatuses } from "./api";
import { useFetch } from "@/hooks/useFetch";
import useTableFilters from "@/hooks/useTableFilters";
import CalendarDatePicker from "ui/components/comp-507";
import FilterWrapper from "components/filter/wrapper";
import FiltersList from "components/filter/list";
import SelectType from "components/select/type";
import { FilterActions } from "components/filter/actions";

export default function BillableFilters({
  filters,
  setFilters,
  setIsOpen,
  defaultFilters,
  clearFilters,
}) {
  const {
    localFilters,
    applyFilters,
    clearLocalFilters,
    handleSetLocalFilters,
  } = useTableFilters({
    filters,
    setFilters,
    setIsOpen,
    clearFilters,
    initialFilters: {
      coordinator: undefined,
      status: undefined,
      billing_date: undefined,
      due_date: undefined,
      ...defaultFilters,
    },
    defaultFilters,
  });

  const { data: billableStatuses } = useFetch({
    queryKey: ["billable-statuses"],
    queryFn: fetchBillableStatuses,
  });

  return (
    <FiltersList>
      {/* Type Filter */}
      <FilterWrapper label="Type">
        <SelectType
          collection="billables"
          value={localFilters?.type?._eq}
          onChange={(selectedItem) => {
            handleSetLocalFilters({
              type: selectedItem ? { _eq: selectedItem } : undefined,
            });
          }}
        />
      </FilterWrapper>

      {/* Status Filter */}
      <div>
        <Label className="mb-2 text-sm">Status</Label>
        <CommonSelect
          placeholder="Select"
          value={localFilters?.status?._eq}
          onValueChange={(selectedItem) =>
            handleSetLocalFilters({
              status: { _eq: selectedItem?.id, __selectedItem: selectedItem },
            })
          }
          items={billableStatuses}
          className="!w-full"
        />
      </div>

      {/* Billing Date */}
      <div>
        <Label className="mb-2 text-sm">Billing Date</Label>
        <CalendarDatePicker
          stack={true}
          date={{
            from: localFilters?.billing_date?._gte,
            to: localFilters?.billing_date?._lte,
          }}
          setDate={(range) => {
            handleSetLocalFilters({
              billing_date: {
                _gte: range?.from
                  ? `${range.from}T00:00:00.000Z`
                  : undefined,
                _lte: range?.to
                  ? `${range.to}T23:59:59.999Z`
                  : undefined,
              },
            });
          }}
          className="w-full"
        />
      </div>

      {/* Due Date */}
      <div>
        <Label className="mb-2 text-sm">Due Date</Label>
        <CalendarDatePicker
          stack={true}
          date={{
            from: localFilters?.due_date?._gte,
            to: localFilters?.due_date?._lte,
          }}
          setDate={(range) => {
            handleSetLocalFilters({
              due_date: {
                _gte: range?.from
                  ? `${range.from}T00:00:00.000Z`
                  : undefined,
                _lte: range?.to
                  ? `${range.to}T23:59:59.999Z`
                  : undefined,
              },
            });
          }}
          className="w-full"
        />
      </div>

      {/* Action Buttons */}
      <FilterActions
        applyFilters={applyFilters}
        clearLocalFilters={clearLocalFilters}
      />
    </FiltersList>
  );
}
